import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiSmpVision {
}
ApiSmpVision.removeBackground = (file) => {
    const fd = new FormData();
    fd.append("image", file);
    return apiRequest({
        body: fd,
        endpoint: REACT_APP__URL_SMP_API + "/vision/v2/remove-background",
        method: "POST",
    });
};
ApiSmpVision.translate = ({ language, strings, }, signal) => apiRequest({
    body: {
        language,
        text_objects: strings,
    },
    endpoint: REACT_APP__URL_SMP_API + "/vision/v2/translate",
    method: "POST",
    signal,
});
//# sourceMappingURL=vision.js.map